import React from 'react'
import { APP_DOMAIN } from '../../constants/constants';
const PageLoader = (props) => {
    const imgSrc = props?.imageColor == "white" ? `/assets/images/spinner-white.svg` : `/assets/images/spinner.svg`
    return (<div className="page-loader">
        <div className="page-spinner" style={{ zIndex: '99999' }}>
            <img className="page-img" src={imgSrc} width="80px" alt="loader" />
        </div>
    </div >)
}
export default PageLoader;